import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0af5dc91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PSLog_Content" }
const _hoisted_2 = { class: "PSLog_Header" }
const _hoisted_3 = {
  key: 0,
  class: "PSLog_Header_Title"
}
const _hoisted_4 = {
  key: 1,
  class: "PSLog_Header_Title"
}
const _hoisted_5 = { class: "PSLog_Main" }
const _hoisted_6 = { class: "PSLog_Table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "入力ユーザー"),
    /*#__PURE__*/_createElementVNode("th", null, "ISBN"),
    /*#__PURE__*/_createElementVNode("th", null, "数量"),
    /*#__PURE__*/_createElementVNode("th", null, "提案ラベル内容"),
    /*#__PURE__*/_createElementVNode("th", null, "入力日時")
  ])
], -1))

import axios from "axios";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Notyf } from "notyf";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSimulationLog',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");
const route = useRoute();
const store = useStore();
const notyf = new Notyf();

// データ取得--------------------------------------------------
const display_data = ref([
  {
    userName: "",
    isbn: "",
    orderQuantity: -1,
    suggestionLabel: "",
    registerDate: "",
    registerTime: "",
  },
]);
const isConfirm = ref(route.query.isConfirm == "1" ? true : false);
const getLogData = async () => {
  try {
    const url = isConfirm.value
      ? "/zaiko-simulation/log-confirm"
      : "/zaiko-simulation/log-order";
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}${url}?uuid=${route.query.uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    display_data.value = res.data;
    console.log(display_data.value);
    console.log(res.data);
  } catch (error) {
    notyf.error("データを取得できませんでした");
    console.log(error);
  }
};
getLogData();

// 日付形式-------------------------------------------------------------
const convertDate = (registerDate: string) => {
  const targetDate = new Date(registerDate);
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1;
  const day = targetDate.getDate();
  const hour = targetDate.getHours();
  const minutes = targetDate.getMinutes();
  const seconds = targetDate.getSeconds();
  return `${year}/${month}/${day} ${String(hour).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isConfirm.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "在庫シミュレーション 確定履歴"))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "在庫シミュレーション 登録・編集履歴"))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(display_data.value, (result, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(result.userName), 1),
              _createElementVNode("td", null, _toDisplayString(result.isbn), 1),
              _createElementVNode("td", null, _toDisplayString(result.orderQuantity), 1),
              _createElementVNode("td", null, _toDisplayString(result.suggestionLabel), 1),
              _createElementVNode("td", null, _toDisplayString(convertDate(result.registerTime)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})